interface OnboardingProgressProps {
  currentStep: number;
  totalSteps: number;
}

/**
 * OnboardingProgress — step indicator with animated dot-pill stepper.
 *
 * Renders "Step X of Y" label followed by dots. The active dot expands into
 * a pill shape with an accent colour, matching the demo's `.cx-ob-dots` pattern.
 */
export function OnboardingProgress({ currentStep, totalSteps }: OnboardingProgressProps) {
  return (
    <div className="gfg-ob-progress">
      <span className="gfg-ob-step">
        Step {currentStep} of {totalSteps}
      </span>
      <span className="gfg-ob-dots">
        {Array.from({ length: totalSteps }, (_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: Steps are static and never reordered
          <span key={i} className={i === currentStep - 1 ? "on" : ""} />
        ))}
      </span>
    </div>
  );
}
